import { ToolbarDropdownMenu, MenuGroup, MenuItem } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import omit from 'lodash/omit';
import { copy, pages} from '@wordpress/icons';

export const CopyPasteStyles = ({ attributes, setAttributes, blockName , exclude=[]}) => {
    const storageKey = `vayu-block-style-${blockName}`;

    const defaultExcluded = ['uniqueId', 'anchor', 'metadata'];
    const allExcluded = [...defaultExcluded, ...exclude];

    const copyAttributes = () => {
        // Explicitly exclude uniqueId, anchor, metadata, and any other non-style attributes
        const transferableAttributes = omit(attributes, allExcluded);
        localStorage.setItem(storageKey, JSON.stringify({
            blockType: blockName,
            attributes: transferableAttributes,
        }));
    };

    const pasteAttributes = () => {
        const stored = JSON.parse(localStorage.getItem(storageKey) || '{}');
        if (stored.blockType === blockName) {
            // Preserve the current block's uniqueId
            const currentUniqueId = attributes.uniqueId;
            // Apply stored attributes, ensuring uniqueId is not overwritten
            setAttributes({
                ...stored.attributes,
                uniqueId: currentUniqueId, // Retain the existing uniqueId
            });
        }
    };

    const stored = JSON.parse(localStorage.getItem(storageKey) || '{}');
    const isPasteAvailable = stored.blockType === blockName;

    const DashiconAppearance = () => (
        <span className="dashicons dashicons-admin-appearance" />
    );

    return (
        <ToolbarDropdownMenu icon={<DashiconAppearance />} label={__('Copy/Paste Styles', 'vayu-blocks')} >
            {({ onClose }) => (
                <MenuGroup className="vb-copy-paste-styling-option">
                    <MenuItem icon={copy} onClick={() => { copyAttributes(); onClose(); }}>
                        {__('Copy Style', 'vayu-blocks')}
                    </MenuItem>

                    <MenuItem icon={pages} onClick={() => { pasteAttributes(); onClose(); }} disabled={!isPasteAvailable}>
                        {__('Paste Style', 'vayu-blocks')}
                    </MenuItem>
                </MenuGroup>
            )}
        </ToolbarDropdownMenu>
    );
};